import { render, staticRenderFns } from "./CustomBoxes.vue?vue&type=template&id=2ab58f06&scoped=true"
import script from "./CustomBoxes.vue?vue&type=script&lang=js"
export * from "./CustomBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab58f06",
  null
  
)

export default component.exports